export default {
  domain: 'YOUR_DOMAIN',
  clientId: 'YOUR_CLIENT_ID',
  redirectUri: 'REDIRECT_URI_ON_LOGIN',
  returnTo: 'REDIRECT_URI_ON_LOGOUT',
};
